import { compose, withState, withHandlers } from 'recompose'
import { includes } from 'lodash'

import { setWrapDisplayName } from 'hoc/setWrapDisplayName'
import { withComponentDidUpdate } from 'hoc/withComponentDidUpdate'
import { formatValue } from 'utils/formatters/value'

const handleCursorPositionDefault =
  ({ inputRef, value, setInputCursorPosition }) =>
  newValue => {
    const formattedNewValue = formatValue(newValue, '')
    const formattedValue = formatValue(value, '')
    const isInclude = includes(formattedNewValue, formattedValue) || includes(formattedValue, formattedNewValue)
    const shouldChange = isInclude && formattedValue !== formattedNewValue

    // 500 - is abstract number, means that cursor should be in the end of input
    setInputCursorPosition({
      start: shouldChange ? 500 : inputRef.selectionStart,
      end: shouldChange ? 500 : inputRef.selectionEnd,
    })
  }

const handleComponentDidUpdate = ({ inputRef, inputCursorPosition }) => {
  if (inputRef === document.activeElement) {
    inputRef.setSelectionRange(inputCursorPosition.start, inputCursorPosition.end)
  }
}

export const withInputMask =
  ({ handleCursorPosition = handleCursorPositionDefault } = {}) =>
  BaseComponent =>
    compose(
      setWrapDisplayName(BaseComponent, 'withInputMask'),
      withState('inputRef', 'setInputRef', null),
      withState('inputCursorPosition', 'setInputCursorPosition', {}),
      withHandlers({ handleInputChange: handleCursorPosition }),
      withComponentDidUpdate(handleComponentDidUpdate),
    )(BaseComponent)
